import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AdminLayout } from "../AdminLayout";
import { useSelector } from "react-redux";
import { selectUser, selectLoading } from "app/slice/selectors";

interface Props {}

export function ProtectedRoute(props: Props) {
  const userSelect = useSelector(selectUser);
  const user = { ...userSelect };
  console.log(window.location.pathname, "window.location.pathname", user?.role);
  if (
    user?.role === "company_user" &&
    window.location.pathname !== "/admin/dashboard"
  ) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return user ? (
    <AdminLayout>
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </AdminLayout>
  ) : (
    <Navigate to="/login" replace />
  );
}
